export enum AuthType {
  Apple = 'apple',
  Google = 'google',
  Email = 'email',
}

export type AuthResponse = {
  token: string;
  refreshToken: string;
};

export type UserInfo = {
  id: string;
};

export type UserProfile = {
  firstName: string;
};
